<template>
<div class="chapter">
<div class="inner_page">
<p class="p6"><span class="t7">By</span> C<span class="t9">AITLIN</span> R<span class="t9">ICCI</span></p>
<p class="p0"><span class="t7">Country Strong</span></p>
<p class="p0"><span class="t7">Cuddling (Dreamspinner Anthology)</span></p>
<p class="p0"><span class="t7">His Lion Tamer</span></p>
<p class="p7"><span class="t7">Marked by Grief</span></p>
<p class="p0"><span class="t10">A F</span><span class="t11">OREVER</span> <span class="t10">H</span><span class="t11">OME</span></p>
<p class="p0"><span class="t7">Rescuing Jack</span></p>
<p class="p2"><span class="t7">Of Monsters and Men</span></p>
<p class="p0"><span class="t13">Published by Harmony Ink Press</span></p>
<p class="p0"><span class="t7">First Time for Everything (Harmony Ink Anthology)</span></p>
<p class="p0"><span class="t7">Weathering the Storm</span></p>
<p class="p8"><span class="t7">Published by</span> D<span class="t9">REAMSPINNER</span> P<span class="t9">RESS</span></p>
<p class="p0"><span class="t7">http://www.dreamspinnerpress.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?64b39ab0